let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("lbV1I")).then(() => parcelRequire('97SvH'));